module.exports = __webpack_public_path__ + "img/Transaction trigger tool1.915df170.jpg";